// @flow

import { type Descriptor, createDescriptor } from '../../controls/router';

export type SortParams = {|
  sortBy: null | string,
  sortDirection: null | string,
|};

export const sortDescriptor: Descriptor<SortParams> = createDescriptor({
  sortBy: null,
  sortDirection: null,
});

export type PageParams = {|
  page: number,
|};

export const pageDescriptor: Descriptor<PageParams> = createDescriptor({
  page: 0,
});

export type LocationParams = {|
  location: string | null,
|};

export const locationDescriptor: Descriptor<LocationParams> = createDescriptor({
  location: null,
});
